import React, { useEffect, useState } from "react";
import * as Icons from "lucide-react";
import { Target, Eye, Rocket } from "lucide-react";
import { useLang, useL } from "@/i18n";
import { api } from "@/lib/api";

export default function About() {
  const { lang, t } = useLang();
  const L = useL();
  const [c, setC] = useState(null);
  useEffect(() => { api.get("/content/about").then((r) => setC(r.data)).catch(() => {}); }, []);
  if (!c) return <div className="grid min-h-[50vh] place-items-center text-navy">{t("common.loading")}</div>;

  const pillars = [
    { icon: Target, title: lang === "fr" ? "Notre Mission" : "Our Mission", body: L(c, "mission") },
    { icon: Eye, title: lang === "fr" ? "Notre Vision" : "Our Vision", body: L(c, "vision") },
    { icon: Rocket, title: lang === "fr" ? "Notre Ambition" : "Our Ambition", body: L(c, "ambition") },
  ];

  return (
    <div data-testid="about-page">
      <section className="relative overflow-hidden bg-navy py-20">
        <img src={c.story_image} alt="" className="absolute inset-0 h-full w-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-b from-navy/70 to-navy/95" />
        <div className="relative mx-auto max-w-3xl px-4 text-center">
          <p className="mb-3 font-script text-3xl text-gold">Lakay toujou nan kè nou</p>
          <h1 className="font-display text-4xl font-bold text-cream sm:text-5xl">{lang === "fr" ? "À propos de Kreyola Boutik" : "About Kreyola Boutik"}</h1>
        </div>
      </section>

      <section className="mx-auto max-w-3xl px-4 py-16">
        <h2 className="mb-5 font-display text-3xl font-bold text-navy">{lang === "fr" ? "Notre Histoire" : "Our Story"}</h2>
        {(L(c, "story") || "").split("\n\n").map((para, i) => (
          <p key={i} className="mb-4 text-lg leading-relaxed text-navy/75">{para}</p>
        ))}
      </section>

      <section className="bg-cream-card py-16">
        <div className="mx-auto max-w-[1400px] px-4">
          <div className="grid gap-6 md:grid-cols-3">
            {pillars.map((p, i) => (
              <div key={i} className="rounded-3xl border border-border bg-cream p-8 card-shadow" data-testid={`about-pillar-${i}`}>
                <div className="mb-4 grid h-14 w-14 place-items-center rounded-2xl bg-navy text-gold"><p.icon size={26} /></div>
                <h3 className="mb-3 font-display text-xl font-bold text-navy">{p.title}</h3>
                <p className="text-sm leading-relaxed text-navy/70">{p.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-[1400px] px-4 py-16">
        <h2 className="mb-8 text-center font-display text-3xl font-bold text-navy">{lang === "fr" ? "Nos Valeurs" : "Our Values"}</h2>
        <div className="grid grid-cols-2 gap-5 md:grid-cols-4">
          {(c.values || []).map((v, i) => {
            const Icon = Icons[v.icon] || Icons.Star;
            return (
              <div key={i} className="flex flex-col items-center gap-3 rounded-2xl border border-border bg-cream-card p-6 text-center card-shadow">
                <div className="grid h-12 w-12 place-items-center rounded-full bg-gold/15 text-gold"><Icon size={22} /></div>
                <span className="font-head font-semibold text-navy">{lang === "fr" ? v.fr : v.en}</span>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
}
